import React from "react";

import InfoSection from "../../components/infoBar/infoSection";

const anchorButtons = (text, headline = "") => {
  if (!text) {
    return null;
  }

  const regex = new RegExp(/<h3( id="(.*?)")?>(.*?)<\/h3>/, "g");
  const titles = Array.from(text.matchAll(regex));
  const output = [];
  let unusedIndex = 0;

  if (titles && titles.length > 2) {
    titles.forEach((item, index) => {
      let id = `anchor-point-${index - unusedIndex + 1}`;

      if (item[2]) {
        // eslint-disable-next-line prefer-destructuring
        id = item[2];
        unusedIndex += 1;
      }

      output.push((
        <a
          className="anchor-button"
          href={`#${id}`}
          key={`#${id}`}
        >
          {index + 1}. {item[3].replace(/<[^>]*>?/gm, "")}
        </a>
      ));
    });

    return (
      <InfoSection sectionHeadline={headline}>
        {output}
      </InfoSection>
    );
  }

  return null;
};

export default anchorButtons;
